import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import OrderListPageUI from './OrderListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

const Sort = {asc: 1, desc: 2, none: 0}

class OrderListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      orderList: null,
      filteredOrderList: null,
      alphaSort: Sort.none,
      timeSort: Sort.desc,
      statusList: null,
      statusFilter: '-1',
      searchFilter: ''
    }
  }

  render() {
    return (
      <OrderListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        orderList={this.state.orderList}
        filteredOrderList={this.state.filteredOrderList}
        alphaSort={this.state.alphaSort}
        timeSort={this.state.timeSort}
        statusList={this.state.statusList}
        statusFilter={this.state.statusFilter}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onAlphaSortClick={this.onAlphaSortClick}
        onTimeSortClick={this.onTimeSortClick}
        onStatusFilterChange={this.onStatusFilterChange}
        onSearchFilterChange={this.onSearchFilterChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getOrders(context)
    this.getMessages(context)
    this.getOrderStatuses(context)
  }

  getOrders(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates`,
      cacheKey: CacheKeys.Orders(context.session.accountId, ''),
      callback: this.getOrdersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrdersCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.OrdersFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      orderList: response.estimateList,
      filteredOrderList: response.estimateList,
      alphaSort: filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      timeSort: filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
      statusFilter: filters.statusFilter ? filters.statusFilter : '-1',
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.estimateList,
      filters.hasOwnProperty('alphaSort') ? filters.alphaSort : Sort.none,
      filters.hasOwnProperty('timeSort') ? filters.timeSort : Sort.desc,
      filters.statusFilter ? filters.statusFilter : '-1',
      filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(orderList, alphaSort, timeSort, statusFilter, searchFilter) {
    let filteredList = orderList.sort((p1, p2) => {
      if (alphaSort)
        return alphaSort === Sort.asc ?
          p1.estimateName.localeCompare(p2.estimateName) : p2.estimateName.localeCompare(p1.estimateName)
      if (timeSort)
        return timeSort === Sort.asc ?
          p1.estimateDate - p2.estimateDate : p2.estimateDate - p1.estimateDate
      return 0
    })

    if (statusFilter !== '-1')
      filteredList = filteredList.filter(order => order.status === statusFilter)
    if (searchFilter)
      filteredList = filteredList.filter(order =>
        order.estimateName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        order.customerName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({filteredOrderList: filteredList})

    let filters = {
      alphaSort: alphaSort,
      timeSort: timeSort,
      statusFilter: statusFilter,
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.OrdersFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onAlphaSortClick = () => {
    let alphaSort = this.state.alphaSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      alphaSort: alphaSort,
      timeSort: Sort.none
    })
    this.applyFilters(this.state.orderList, alphaSort, Sort.none,
      this.state.statusFilter, this.state.searchFilter)
  }

  onTimeSortClick = () => {
    let timeSort = this.state.timeSort === Sort.asc ? Sort.desc : Sort.asc
    this.setState({
      timeSort: timeSort,
      alphaSort: Sort.none
    })
    this.applyFilters(this.state.orderList, Sort.none, timeSort,
      this.state.statusFilter, this.state.searchFilter)
  }

  onStatusFilterChange = (value) => {
    this.setState({statusFilter: value})
    this.applyFilters(this.state.orderList, this.state.alphaSort, this.state.timeSort,
      value, this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.orderList, this.state.alphaSort, this.state.timeSort,
      this.state.statusFilter, searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    let filter = ''
    if (! context.permissions.includes('acc_manage')) {
      filter = context.session.userId
    }
    CacheManager.removeObject(CacheKeys.Orders(context.session.accountId, filter))
    this.setState({
      errorList: null,
      orderList: null,
      filteredOrderList: null
    })
    this.getOrders(context)
  }

  getOrderStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/orderStatuses`,
      cacheKey: CacheKeys.OrderStatuses(),
      callback: this.getOrderStatusesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getOrderStatusesCallback = (response) => {
    this.setState({statusList: response.list.map(item => ({value: item.key, label: item.value}))})
  }

  getMessages(context) {
    let arr = [
      'c_cust_orders',
      'c_refresh',
      'c_create_order',
      'c_no_order_msg',
      'c_sort_alpha',
      'c_sort_time',
      'c_all',
      'c_status_done',
      'c_cancelled',
      'c_due_date',
      'c_completion_date',
      'c_cancel_date'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_orders', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(OrderListPageSF)
